export const    DEVICE = 'DEVICE';
export const    DEVICE_SUCCESS = 'DEVICE_SUCCESS';
export const    DEVICE_ERROR = 'DEVICE_ERROR';
export const    DEVICE_ALL_SUCCESS = 'DEVICE_ALL_SUCCESS';


export const    DEVICE_SORT = 'DEVICE_SORT';
export const    DEVICE_SORT_SUCCESS = 'DEVICE_SORT_SUCCESS';
export const    DEVICE_SORT_ERROR = 'DEVICE_SORT_ERROR';

export const    DEVICE_RESIDENTS = 'DEVICE_RESIDENTS';
export const    DEVICE_RESIDENTS_SUCCESS = 'DEVICE_RESIDENTS_SUCCESS';
export const    DEVICE_RESIDENTS_ERROR = 'DEVICE_RESIDENTS_ERROR';

export const    DEVICE_LOCATIONS = 'DEVICE_LOCATIONS';
export const    DEVICE_LOCATIONS_SUCCESS = 'DEVICE_LOCATIONS_SUCCESS';
export const    DEVICE_LOCATIONS_ERROR = 'DEVICE_LOCATIONS_ERROR';

export const    DEVICE_SERIALS = 'DEVICE_SERIALS';
export const    DEVICE_SERIALS_SUCCESS = 'DEVICE_SERIALS_SUCCESS';
export const    DEVICE_SERIALS_ERROR = 'DEVICE_SERIALS_ERROR';

export const    DEVICE_DOCSIS = 'DEVICE_DOCSIS';
export const    DEVICE_DOCSIS_SUCCESS = 'DEVICE_DOCSIS_SUCCESS';
export const    DEVICE_DOCSIS_ERROR = 'DEVICE_DOCSIS_ERROR';

export const    DEVICE_ID = 'DEVICE_ID';
export const    DEVICE_ID_SUCCESS = 'DEVICE_ID_SUCCESS';
export const    DEVICE_ID_ERROR = 'DEVICE_ID_ERROR';

export const    ADD_DEVICE = 'ADD_DEVICE';
export const    ADD_DEVICE_SUCCESS = 'ADD_DEVICE_SUCCESS';
export const    ADD_DEVICE_ERROR = 'ADD_DEVICE_ERROR';

export const    UPDATE_DEVICE = 'UPDATE_DEVICE';
export const    UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const    UPDATE_DEVICE_ERROR = 'UPDATE_DEVICE_ERROR';

export const    CLEAR_DEVICES= 'CLEAR_DEVICES';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_ERROR = 'ADD_MESSAGE_ERROR';

export const ADD_MESSAGE_FILTERS = 'ADD_MESSAGE_FILTERS';
export const ADD_MESSAGE_FILTERS_SUCCESS = 'ADD_MESSAGE_FILTERS_SUCCESS';
export const ADD_MESSAGE_FILTERS_ERROR = 'ADD_MESSAGE_FILTERS_ERROR';

export const UNREGISTER_RESIDENTS = 'UNREGISTER_RESIDENTS';
export const UNREGISTER_RESIDENTS_SUCCESS = 'UNREGISTER_RESIDENTS_SUCCESS';
export const UNREGISTER_RESIDENTS_ERROR = 'UNREGISTER_RESIDENTS_ERROR';

export const UNREGISTER_RESIDENTS_FILTERS = 'UNREGISTER_RESIDENTS_FILTERS';
export const UNREGISTER_RESIDENTS_FILTERS_SUCCESS = 'UNREGISTER_RESIDENTS_FILTERS_SUCCESS';
export const UNREGISTER_RESIDENTS_FILTERS_ERROR = 'UNREGISTER_RESIDENTS_FILTERS_ERROR';

export const EXPORT_DEVICE = 'EXPORT_DEVICE';
export const EXPORT_DEVICE_SUCCESS = 'EXPORT_DEVICE_SUCCESS';
export const EXPORT_DEVICE_ERROR = 'EXPORT_DEVICE_ERROR';